import React from 'react';
import PropTypes from 'prop-types';

const isNotPrivateProp = propName => !/^_.*/.test(propName);
const ignoreFirstArg = fn => (a1, ...rest) => fn && fn(...rest);

const pickBy = (obj, filter) => Object.keys(obj).filter(filter).reduce((result, key) => {
    result[key] = obj[key];
    return result;
}, {});

export default function BaseComponent({
// eslint-disable-next-line react/prop-types
                                          theme, as = 'div', ref, refCb, children, ...rest
                                      }) {
    return React.createElement(as, {...pickBy(rest, ignoreFirstArg(isNotPrivateProp)), ref: ref || refCb}, children);
}

BaseComponent.propTypes = {
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.func]),
    refCb: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};
